// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CAjUj","text":"styles_text__2oX7Q"};